/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GenericApiResponseResourceData } from './genericApiResponseResourceData';
import type { GenericApiResponseResourceMessage } from './genericApiResponseResourceMessage';
import type { GenericApiResponseResourcePagination } from './genericApiResponseResourcePagination';
import type { GenericApiResponseResourceError } from './genericApiResponseResourceError';

export interface GenericApiResponseResource {
  data?: GenericApiResponseResourceData;
  message?: GenericApiResponseResourceMessage;
  pagination?: GenericApiResponseResourcePagination;
  error?: GenericApiResponseResourceError;
  statusCode?: number;
}
